import { mutatorAction } from 'satcheljs';
import { getProactiveDraftsStore } from '../store/store';

const setProactiveDraftsBarExpandedMutator: (
    itemId: string | undefined,
    isExpanded: boolean
) => void = mutatorAction(
    'setProactiveDraftsBarExpandedMutator',
    function setProactiveDraftsBarExpanded(itemId: string | undefined, isExpanded: boolean): void {
        if (!itemId) {
            return;
        }

        // Set the proactive drafts bar expanded/collapsed state for the given key
        const proactiveDraftsStore = getProactiveDraftsStore();
        const proactiveDraftsState = proactiveDraftsStore.proactiveDraftsListMap.get(itemId);
        if (proactiveDraftsState) {
            proactiveDraftsState.proactiveDraftsBarExpanded = isExpanded;
        }
    }
);
export default setProactiveDraftsBarExpandedMutator;
